export const HIDE_INPUT_TEXT = '****************************';
export const NA_TEXT = '<n/a>';
